import { Pipe, PipeTransform } from "@angular/core";

import { StringFormatPattern } from "../types";
import { FormatNumber } from "../services/FormatNumber";

export enum FORMAT_PATTERN {
  NUMBER = "number",
  CURRENCY = "currency"
}

@Pipe({
  name: "stringFormat",
  pure: false,
})
export class StringFormat implements PipeTransform {
  transform(value: string | number, pattern?: StringFormatPattern, precision?: number): string {
    switch (pattern) {
    case FORMAT_PATTERN.NUMBER:
      return new FormatNumber(value, precision).number;
    case FORMAT_PATTERN.CURRENCY:
      return new FormatNumber(value).currency;
    default:
      return value.toString();
    }
  }
}
